<template>
  <div>
    <!-- 案例展示 -->
    <div class="case-section">
      <div class="container">
        <div class="case-header">
          <div class="report-title">案例展示<span style="color: #F66F00;text-align: center !important;">•</span></div>
          <!-- <h2>案例展示<span style="color: #F66F00;">•</span></h2> -->
          <div class="news-subtitle">CASE SHOWCASE</div>
        </div>
        <div class="case-grid">
          <div class="case-item" v-for="(item, index) in list" :key="index" @click="handleClick(item)">
            <div class="case-image">
              <img :src="httphosts + item.cover" alt="案例1">
            </div>
            <div class="case-title">{{item.title}}</div>
          </div>
        </div>
        <div class="u-h-60"></div>
        <el-empty :image-size="200" v-if="list.length === 0"></el-empty>
        <!-- 分页 -->
        <div class="u-flex u-row-center" v-if="list.length !== 0">
            <el-pagination
              layout="prev, pager, next"
              background
              :total="records"
              :current-page.sync="page"
              :page-size.sync="limit"
              @current-change="getlist"
              @size-change="getlist"
            />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { caseShowcase } from '@/api/index'
import { httphosts } from '@/utils/global'

export default {
  data() {
    return {
      httphosts: httphosts,
      list: [],
      records: 0,
      page: 1,
      limit: 6,
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    // 获取案例展示
    getlist() {
      this.caseloading = true;
      caseShowcase({
        page: this.page,
        limit: this.limit
      }).then(res => {
        if (res.code === 1) {
          this.list = res.data.list
          this.records = res.data.total
        }
      }).finally(() => {
        this.caseloading = false
      })
    },
    handleClick(item) {
      this.$router.push({ path: '/caseDetails', query: { id: item.id } }).catch(() => { })
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
}
.report-title {
  font-size: 30px;
  color: #1B5AFF;
  margin-bottom: 0;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
}
.news-subtitle {
  font-size: 24px;
  color: #DDE4EA;
  /* margin-bottom: 30px; */
}
/* 案例展示部分样式 */
.case-section {
  padding: 60px 0;
  background: #f9f9f9;
}

.case-header {
  text-align: center;
  margin-bottom: 40px;
}

.case-header h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.case-header p {
  font-size: 16px;
  color: #1B5AFF;
  margin: 0;
}

/* 案例网格 */
.case-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.case-item {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;

}

.case-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  background: #111B5B;
  color: #fff !important;
}

.case-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.case-item:hover .case-image img {
  transform: scale(1.05);
}

.case-title {
  font-size: 14px;
  padding: 15px;
  font-weight: bold;
  line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .case-section {
    padding: 40px 0;
  }

  .case-header h2 {
    font-size: 24px;
  }

  .case-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }

  .case-image {
    height: 150px;
  }

  .case-title {
    font-size: 12px;
    padding: 12px;
  }
}
</style>